// workshop management
const workshopUrl = '/app/workshop'

export const getWorkshopPage = () => `${workshopUrl}`
export const createWorkshop = () => `${workshopUrl}`
export const updateWorkshop = (id) => `${workshopUrl}/${id}`
export const deleteWorkshop = (id) => `${workshopUrl}/${id}`
